type HoursProps = {
  ProjectId: number;
  TotalHours: string;
  StatusId: number;
};

export const CountProject = (dataset: HoursProps[]): number => {
  let projectCount = 0;
  dataset.forEach((element) => {
    if (element.ProjectId !== null || element.ProjectId !== undefined) {
      projectCount += 1;
    }
  });
  return projectCount;
};

export const CountTimeSheetApproved = (dataset: HoursProps[]): number => {
  let timeSheetApproved = 0;
  dataset.forEach((element) => {
    if (element.StatusId === 3) {
      timeSheetApproved += 1;
    }
  });
  return timeSheetApproved;
};

export const CountTimeSheetInProgress = (dataset: HoursProps[]): number => {
  let timeSheetInProgress = 0;
  dataset.forEach((element) => {
    if (element.StatusId === 1) {
      timeSheetInProgress += 1;
    }
  });
  return timeSheetInProgress;
};

export const CountTimeSheetInAnalysis = (dataset: HoursProps[]): number => {
  let timeSheetInAnalysis = 0;
  dataset.forEach((element) => {
    if (element.StatusId === 2) {
      timeSheetInAnalysis += 1;
    }
  });
  return timeSheetInAnalysis;
};

export const SumWorkHours = (dataset: HoursProps[]): string => {
  let timeString = "";
  let totalHours = 0;
  let totalMinutes = 0;

  dataset.forEach((element) => {
    timeString = element.TotalHours;
    // Divida a string nos dois pontos para obter horas e minutos
    const [hours, minutes] = timeString.split(":");

    // Converta as partes para números inteiros
    const hoursParse = parseInt(hours, 10);
    const minutesParse = parseInt(minutes, 10);

    // Sum Total Hours and minutos
    totalHours += hoursParse;
    totalMinutes += minutesParse;
  });
  // Calcule o total de minutos
  const calculeMinutes = totalHours * 60 + totalMinutes;

  // Extrai as horas e os minutos do total de minutos
  let convertedHours = Math.floor(calculeMinutes / 60);
  let convertedMinutes = calculeMinutes % 60;

  return convertedHours + "H" + convertedMinutes + "min";
};
